var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymentGooglePay24 = function SvgPaymentGooglePay24(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.1224C17.5 11.7481 17.4689 11.3738 17.4065 11.0072H12.114V13.1231H15.1461C15.0214 13.8029 14.6161 14.414 14.0237 14.7959C13.517 15.1321 12.8703 15.323 12.1143 15.323C10.6489 15.323 9.40956 14.3529 8.96527 13.0543C8.7314 12.3744 8.7314 11.6412 8.96527 10.9537C9.40956 9.64748 10.6489 8.67736 12.1143 8.67736C12.9171 8.66208 13.6888 8.95999 14.2656 9.50234L15.8712 7.92877C14.8502 6.99685 13.5095 6.48506 12.1143 6.50033C9.99415 6.50033 8.05316 7.67672 7.10222 9.53292C6.29926 11.0836 6.29926 12.9169 7.10222 14.4675C8.05316 16.3237 9.99415 17.5 12.1143 17.5C13.6264 17.5 14.9045 17.0112 15.832 16.1709C16.8921 15.2161 17.5 13.8029 17.5 12.1224Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentGooglePay24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PaymentGooglePay24.6c980130302afa9f28bf4ae5a098600f.svg";